export const registerServiceWorker = () => {
  if (
    process.env.NODE_ENV !== "production" ||
    !("serviceWorker" in navigator)
  ) {
    return;
  }

  const register = () => {
    const publicPath = new URL(
      process.env.PUBLIC_URL || "/",
      window.location.origin,
    ).pathname.replace(/\/$/, "");

    navigator.serviceWorker
      .register(`${publicPath}/service-worker.js`)
      .then((registration) => registration.update())
      .catch((error) => console.log("Service worker registration failed:", error));
  };

  if (document.readyState === "complete") {
    register();
  } else {
    window.addEventListener("load", register, { once: true });
  }
};
